import React, { createContext, useContext, useState } from "react";

const ImageSelectorContext = createContext();

export const ImageSelectorProvider = ({ children }) => {
  const [images, setImages] = useState([]);

  const addImage = (imagePath) => {
    setImages((prevImages) => [...prevImages, imagePath]);
  };

  const removeImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  return (
    <ImageSelectorContext.Provider value={{ images, addImage, removeImage }}>
      {children}
    </ImageSelectorContext.Provider>
  );
};

export const useImageSelector = () => useContext(ImageSelectorContext);
